<template>
  <div class="view-account container-fluid pt-5">
    <div class="row mb-4">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="card-account" :style="accountStyle">
          <h4 class="mb-4">Minha conta</h4>
          <form @submit.prevent="submit">
            <form-group
              id="email"
              v-model="form.email"
              :errors="errors.email"
              type="email"
              placeholder="Seu e-mail"
              readonly
              label="E-mail"
            />

            <form-group
              id="name"
              v-model="form.name"
              :errors="errors.name"
              type="text"
              placeholder="Seu nome"
              label="Nome"
            />

            <form-group
              id="phone"
              v-model="form.phone"
              :errors="errors.phone"
              type="text"
              placeholder="Número de celular"
              label="Telefone"
            />

            <div class="d-flex justify-content-end">
              <button
                type="submit"
                class="btn btn-light px-4"
                :disabled="loading"
                :style="accountStyleButton"
              >
                <loading :show="loading">Salvar</loading>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6 ">
        <div class="card-account" :style="accountStyle">
          <h4 class="mb-4">Alterar senha</h4>
          <change-password />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card-account" :style="accountStyle">
          <h4 class="mb-4">Histórico de notas</h4>
          <grade-history />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import ChangePassword from "@/components/account/ChangePassword";
import GradeHistory from "@/components/account/GradeHistory";

export default {
  components: { ChangePassword, GradeHistory },
  data() {
    return {
      loading: false,
      ...formFields(["name", "phone", "email"], {
        ...this.$user.user
      })
    };
  },
  computed: {
    accountStyle() {
      const accountCard =
        this.$setup.theme === "dark"
          ? { background: "#181523" }
          : { background: "#FFF" };
      return accountCard;
    },
    accountStyleButton() {
      const accountButton =
        this.$setup.theme === "dark"
          ? { background: "#FFF" }
          : { background: "#6B3EAD", color: "#FFF" };
      return accountButton;
    }
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/update", this.form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.view-account {
  h4 {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  .card-account {
    border-radius: 8px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    padding: 16px 16px 24px 16px;
  }
}
</style>
